import moment from 'moment';
import { portalRequest } from './services';
import { organizationRequest } from '../MinhaOrganizadora/services';

const iso = (value) => (value ? new Date(value).toISOString() : null);
export const localDate = (value) => (value ? moment(value).format('YYYY-MM-DDTHH:mm') : '');
export function selectionPayload(form, selection) {
  const data = new FormData(form);
  return {
    ontest_faculdade_id: selection.ontest_faculdade_id,
    title: data.get('title'),
    status: data.get('status'),
    enabled: data.has('enabled'),
    public_status: data.get('public_status') || null,
    registration_starts_at: iso(data.get('registration_starts_at')),
    registration_ends_at: iso(data.get('registration_ends_at')),
    description: data.get('description'),
    terms: data.get('terms'),
    requires_review: data.has('requires_review'),
    allow_cancellation: data.has('allow_cancellation'),
    schedule: JSON.parse(data.get('schedule') || '[]'),
  };
}
export function positionPayload(form, source, portal) {
  const data = new FormData(form),
    prefix = `cargo_${source.id}_`;
  const value = (key) => data.get(prefix + key) || '';
  return {
    sourceId: source.id,
    portalId: portal?.id || null,
    source: {
      portal_position_enabled: data.has(prefix + 'portal_position_enabled'),
      portal_exam_enabled: data.has(prefix + 'portal_exam_enabled'),
      portal_exam_starts_at: iso(value('portal_exam_starts_at')),
      portal_exam_ends_at: iso(value('portal_exam_ends_at')),
    },
    portal: {
      title: value('title'),
      code: value('code'),
      locality: value('locality'),
      description: value('description'),
      requirements: value('requirements'),
      vacancies: value('vacancies') === '' ? null : Number(value('vacancies')),
      published: data.has(prefix + 'published'),
    },
  };
}
const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);
export async function savePositionConfiguration({
  organization,
  token,
  selection,
  position,
  saved,
}) {
  let step = 'Habilitação e acesso à prova';
  let completed = 0;
  try {
    if (!same(position.source, saved.source)) {
      await organizationRequest(
        token,
        `organizadora/${organization}/seletivos/${selection.ontest_faculdade_id}/cargos/${position.sourceId}/inscricoes`,
        'PUT',
        position.source
      );
      saved.source = position.source;
      saved.sourceChanged = true;
      completed++;
    }
    if (!same(position.portal, saved.portal) || (!saved.portalId && position.portal.published)) {
      step = 'Publicação';
      if (!saved.portalId && !position.source.portal_position_enabled)
        throw new Error('Habilite a inscrição antes de publicar esta opção no portal.');
      const result = await portalRequest(
        organization,
        token,
        `selecoes/${selection.id}/cargos${saved.portalId ? '/' + saved.portalId : ''}`,
        saved.portalId ? 'PUT' : 'POST',
        {
          ...position.portal,
          ...(!saved.portalId ? { ontest_processo_id: Number(position.sourceId) } : {}),
        }
      );
      saved.portalId = result.data.id;
      saved.portal = position.portal;
      completed++;
    }
    return { completed, sourceChanged: !!saved.sourceChanged };
  } catch (error) {
    saved.partiallySaved = saved.partiallySaved || completed > 0;
    const failure = new Error(
      `${step}: ${error.message}${
        saved.partiallySaved
          ? ' Algumas alterações já foram salvas. Tente novamente para concluir as pendentes.'
          : ''
      }`
    );
    failure.fields = error.fields;
    throw failure;
  }
}


export async function saveSelectionConfiguration({ organization, token, selection, data }) {
  let sourceSaved = false;
  try {
    if (data.enabled !== selection.enabled) {
      await organizationRequest(
        token,
        `organizadora/${organization}/seletivos/${selection.ontest_faculdade_id}/inscricoes`,
        'PUT',
        { portal_enabled: data.enabled }
      );
      sourceSaved = true;
    }
    return await portalRequest(organization, token, `selecoes/${selection.id}`, 'PUT', data);
  } catch (error) {
    if (!sourceSaved) throw error;
    const failure = new Error(`A habilitação foi salva na OnTest, mas a configuração do portal não foi concluída. Tente salvar novamente. ${error.message}`);
    failure.fields = error.fields || {};
    throw failure;
  }
}
